import { useCallback, useRef } from "react";
import { useSelf } from "../hooks";
import { useEditMode } from "./EditModeContext";
import { onBlocked } from "./editModeState";

export const useIsEditModeReadOnly = () => {
  const { isEditMode } = useEditMode();
  const [self] = useSelf();

  return self?.globalRole === "ADMIN" && !isEditMode;
};

export const useEditModeReadOnlyGuard = () => {
  const isReadOnly = useIsEditModeReadOnly();
  const isReadOnlyRef = useRef(isReadOnly);
  isReadOnlyRef.current = isReadOnly;

  return useCallback(() => {
    // Keep this callback stable while reading the current mode so delayed callbacks (such as
    // debounced editor saves) do not retain the read-only state from their first render.
    if (!isReadOnlyRef.current) {
      return false;
    }

    onBlocked(true);
    return true;
  }, []);
};
